import React, { useState, useEffect, useRef, useCallback } from "react";
import { BotonLetras, BotonCancelar } from "../Plantillas/Botones.js";
import '../styles/Kardex.css';
import sunat from "../images/sunat.png"
import sinComprobantes from "../images/sinComprobantes.jpg"
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify.js";
import swal from "sweetalert";
import Modal from "../clientes/ClienteModal";
import "../../componentes/styles/Kardex.css"

const CARACTERES_CAPTCHA = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
const LONGITUD_CAPTCHA = 5;

const generarTextoCaptcha = () => {
    let texto = "";
    for (let i = 0; i < LONGITUD_CAPTCHA; i++) {
        texto += CARACTERES_CAPTCHA.charAt(Math.floor(Math.random() * CARACTERES_CAPTCHA.length));
    }
    return texto;
};

const EscogerStockInicial = (props) => {

    const [codigoUsuarios, setCodigoUsuarios] = useState([]);
    const [codigoUsuarioInput, setCodigoUsuarioInput] = useState("");
    const [showModalValidacion, setShowModalValidacion] = useState(false);
    const [showModalCaptcha, setShowModalCaptcha] = useState(false);
    const [captchaValor, setCaptchaValor] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const canvasCaptchaRef = useRef(null);

    useEffect(() => {
        fetchCodigoValidacion();
    }, []);

    const dibujarCaptcha = useCallback((canvas, texto) => {
        if (!canvas || !texto) return;
        const ctx = canvas.getContext("2d");
        const w = canvas.width;
        const h = canvas.height;
        ctx.clearRect(0, 0, w, h);
 
        ctx.fillStyle = "#f0f0f0";

        ctx.fillRect(0, 0, w, h);
        for (let i = 0; i < 4; i++) {
            ctx.strokeStyle = `rgba(120,120,120,${0.2 + Math.random() * 0.3})`;
            ctx.beginPath();
            ctx.moveTo(Math.random() * w, Math.random() * h);
            ctx.lineTo(Math.random() * w, Math.random() * h);
            ctx.stroke();
        }

        for (let i = 0; i < 12; i++) {
            ctx.fillStyle = `rgba(100,100,100,${0.1 + Math.random() * 0.2})`;
            ctx.fillRect(Math.random() * w, Math.random() * h, 2, 2);
        }

        const anchoChar = w / (texto.length + 1);
        ctx.font = "bold 26px Arial";
        ctx.textBaseline = "middle";
        for (let i = 0; i < texto.length; i++) {
            ctx.save();
            const x = anchoChar * (i + 0.6) + (Math.random() * 6 - 3);
            const y = h / 2 + (Math.random() * 8 - 4);
            ctx.translate(x, y);
            ctx.rotate((Math.random() * 0.4 - 0.2));
            ctx.fillStyle = "#333";
            ctx.fillText(texto[i], 0, 0);
            ctx.restore();
        }
    }, []);

    const iniciarCaptcha = useCallback(() => {
        const texto = generarTextoCaptcha();
        setCaptchaValor(texto);
        setCaptchaInput("");
    }, []);

    useEffect(() => {
        if (showModalCaptcha && captchaValor) {
            const canvas = canvasCaptchaRef.current;
            if (canvas) dibujarCaptcha(canvas, captchaValor);
        }
    }, [showModalCaptcha, captchaValor, dibujarCaptcha]);

    const fetchCodigoValidacion = async () => {
        try {
            const req = await fetch('/api/usuarios/codigoConfirmacion/sucursal');
            const res = await req.json();

            if (req.ok) {
                setCodigoUsuarios(res.map(c => c.Codigo));
            }
        } catch (e) {
            console.error(e);
        }
    }

    const openModalValidacion = () => {
        setShowModalValidacion(true);
    }

    const ejecutarReinicio = async () => {
        document.body.classList.add("swal-reiniciar-stock");
        const restart = await swal({
            title: "¿Está seguro?",
            text: "¿Desea reiniciar el stock de todos los productos?",
            icon: "warning",
            buttons: ["Cancelar", "OK"],
            dangerMode: true,
            closeOnClickOutside: false
        }).finally(() => {
            document.body.classList.remove("swal-reiniciar-stock");
        });

        if (!restart) {
            return;
        }

        try {
            const req = await fetch('/api/kardex/reiniciar-stock');
            if (!req.ok) {
                throw new Error('Error en la petición');
            }

            notificarMsg('Stock reiniciado exitosamente');
        } catch (error) {
            notificarError('Intente nuevamente! Ocurrió un error al reiniciar el stock.');
        }
    };

    const validarCodigoUsuario = () => {
        const codigoInput = codigoUsuarioInput;
        setCodigoUsuarioInput("");

        const validCode = codigoUsuarios.some(c => c == codigoInput);

        if (!validCode) {
            notificarMsg('El codigo ingresado no es correcto.', 'warning');
            return;
        }

        notificarMsg("Código correcto. Complete la verificación.");
        setShowModalValidacion(false);
        iniciarCaptcha();
        setShowModalCaptcha(true);
    }

    const validarCaptcha = () => {
        const ingresado = (captchaInput || "").trim().toUpperCase();
        const esperado = (captchaValor || "").toUpperCase();

        if (ingresado !== esperado) {
            notificarMsg('El texto no coincide. Intente de nuevo.', 'warning');
            iniciarCaptcha();
            return;
        }

        notificarMsg("Validación completada exitosamente.");
        setShowModalCaptcha(false);
        ejecutarReinicio();
    }

    const onValidarCodigoKeyDown = (event) => {
        if (event.key === "Enter") {
            validarCodigoUsuario();
        }
    }

    const onValidarCaptchaKeyDown = (event) => {
        if (event.key === "Enter") {
            validarCaptcha();
        }
    }

    const cerrarModalCaptcha = () => {
        setShowModalCaptcha(false);
        setCaptchaInput("");
        setCaptchaValor("");
    }

    return (
        <React.Fragment>
            <div className="ProcesarBoton mt-1">
                <BotonCancelar
                    onClick={props.history.goBack}
                    className="ml-4"
                />
            </div>

            <div className="kardex__container">
                <div className="kardex">
                    <div className="reporteVentasProd">

                        <div className="KardexDocumento mb-4 mt-4" >
                            <div className="imgcomprobante">
                               <img src={sunat} alt="comprobante"/>
                            </div>
                            <div className="input__KardexDivSmall imgcomprobante mt-4">
                                <BotonLetras
                                    type="button"
                                    to="/stockinicial"
                                >Con Comprobante
                                </BotonLetras>
                            </div>
                        </div>

                        <div className="KardexDocumento mb-4" >
                            <div className="imgcomprobante">
                               <img src={sinComprobantes} style={{height: '83px'}} alt="sin comprobante"/>
                            </div>
                            <div className="input__KardexDivSmall imgcomprobante mt-2">
                                <BotonLetras
                                    type="button"
                                    to="/stockinicialSC"
                                >Sin Comprobante
                                </BotonLetras>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="kardek">
                    <div className="reporteVentasProd">
                        <BotonLetras
                            type="button"
                            onClick={openModalValidacion}
                        >Reiniciar stock
                        </BotonLetras>
                    </div>
                </div>
            </div>

            <Modal isOpen={showModalValidacion} onClose={() => setShowModalValidacion(false)} width='900px'
                   title="Validar Reinicio de Stock">
                <label className="font-weight-bold" htmlFor="inputValidacion">
                    Codigo
                </label>
                <input type="password"
                       name="inputValidacion"
                       value={codigoUsuarioInput}
                       className="form-control mb-2"
                       onChange={e => setCodigoUsuarioInput(e.target.value)}
                       onKeyDown={onValidarCodigoKeyDown}/>

                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-verde-mfp-letra-normal"
                        title="Validar"
                        onClick={validarCodigoUsuario}
                    >Validar</button>
                </div>
            </Modal>

            <Modal isOpen={showModalCaptcha} onClose={cerrarModalCaptcha} width='400px'
                   title="Verificación adicional">
                <p className="mb-2 small text-muted">Ingrese el texto que ve en la imagen:</p>
                <div className="mb-2 d-flex align-items-center">
                    <canvas
                        ref={canvasCaptchaRef}
                        width={200}
                        height={56}
                        style={{ border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f0f0f0' }}
                        title="Texto de verificación"
                    />
                    <button
                        type="button"
                        className="btn btn-link btn-sm ml-2"
                        onClick={iniciarCaptcha}
                        title="Generar otro código"
                    >
                        Regenerar
                    </button>
                </div>
                <label className="font-weight-bold" htmlFor="inputCaptcha">
                    Texto
                </label>
                <input
                    type="text"
                    id="inputCaptcha"
                    name="inputCaptcha"
                    value={captchaInput}
                    className="form-control mb-2"
                    onChange={e => setCaptchaInput(e.target.value)}
                    onKeyDown={onValidarCaptchaKeyDown}
                    autoComplete="off"
                    placeholder="Ej: MFP123"
                />
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-verde-mfp-letra-normal"
                        title="Validar"
                        onClick={validarCaptcha}
                    >Validar</button>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default EscogerStockInicial;
